import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ServicesContext } from '~/services';
import { useServiceSubscribe } from '~/util';

// Type assertion for TypeScript 5.x compatibility with react-router-dom v5
const LinkComponent = Link as any;

type DropdownLinkType = { href: string; title: string; target?: string };

// user type will come from UserService once migrated to TS
function getLinks(user: TODO_TYPEME) {
    const LINKS = {
        admin: { href: '/admin/users', title: 'Admin' },
        logout: { href: '/logout', title: 'Sign out' },
        user: { href: '/user', title: 'User Settings' },
        resources: { href: '/resources', title: 'Resource Center' },
        privacy: {
            href: 'https://leadingreach.com/privacy-policy/',
            title: 'Privacy Policy',
            target: '_blank',
        },
        tos: {
            href: 'https://leadingreach.com/software-services-terms-and-conditions/',
            title: 'Terms of Service',
            target: '_blank',
        },
    };
    if (
        user.isGlobalAdmin() ||
        user.isOrganizationAdmin() ||
        user.isMACLAdmin() ||
        user.isReportYearAdmin()
    ) {
        if (!(user.isGlobalAdmin() || user.isOrganizationAdmin())) {
            if (user.isMACLAdmin()) {
                LINKS.admin.href = '/admin/macl';
            } else if (user.isReportYearAdmin()) {
                LINKS.admin.href = '/admin/reportyear';
            }
        }
        return [LINKS.user, LINKS.admin, LINKS.resources, LINKS.privacy, LINKS.tos, LINKS.logout];
    }
    return [LINKS.user, LINKS.resources, LINKS.privacy, LINKS.tos, LINKS.logout];
}

function getLabel(user: UserType) {
    if (user?.first_name && user?.last_name) {
        return `${user.first_name} ${user.last_name}`;
    }
    return 'User';
}

export function Dropdown() {
    const servicesContext = React.useContext(ServicesContext);
    const user = servicesContext.user.get();

    const [label, setLabel] = React.useState(getLabel(user));
    const [links, setLinks] = React.useState(getLinks(servicesContext.user));

    function isExternalLink(link: DropdownLinkType) {
        return link.href[0] !== '/';
    }

    function handleSubscriptionChange() {
        const userUpdated = servicesContext.user.get();
        setLabel(getLabel(userUpdated));
        setLinks(getLinks(servicesContext.user));
    }

    useServiceSubscribe(servicesContext.user.events.userUpdated, handleSubscriptionChange);

    return (
        <NavDropdown
            as="li"
            title={
                <span>
                    <span className="thumb">
                        <img src="/avatar_default.jpg" alt="User Avatar" />
                    </span>
                    <span id="nav-user-name" className="d-none d-md-inline ms-2">
                        {label}
                    </span>
                </span>
            }
        >
            <div className="dropdown-header d-md-none">{label}</div>
            {links.map((link: DropdownLinkType) => (
                <NavDropdown.Item
                    as={!isExternalLink(link) ? LinkComponent : 'a'}
                    to={!isExternalLink(link) ? link.href : undefined}
                    href={isExternalLink(link) ? link.href : undefined}
                    key={link.title}
                    target={link.target ? link.target : undefined}
                >
                    {link.title}
                </NavDropdown.Item>
            ))}
        </NavDropdown>
    );
}
